import { format }     from 'date-fns';
import { parseISO }   from 'date-fns';
import MessagePreview from './message_preview';
import React          from 'react';
import Recipients     from './recipients';


export default function SentStatusPage({ campaign }) {
  return (
    <>
      <Description {...{ campaign }}/>
      <Recipients {...{ campaign }}/>
      <MessagePreview {...{ campaign }}/>
    </>
  );
}


function Description({ campaign }) {
  const { sentAt }    = campaign;
  const date          = parseISO(sentAt);
  const formattedDate = format(date, 'EEEE, MMMM do, yyyy');
  const formattedTime = format(date, 'h:mm aaaa');
  return (
    <div className="block description">
      <h2>Your campaign was sent on {formattedDate} at {formattedTime}</h2>
    </div>
  );
}
